export default {
  'users.title': 'Gestionar Usuarios',
  'users.userGroup': 'Grupo de Usuarios',
  'users.title.detail': 'DETALLE',
  'users.extraUserFields': 'Campos extra de usuario',

  'users.form.email': 'Correo Electrónico',
  'users.form.names': 'Nombres',
  'users.form.lastNames': 'Apellidos',
  'users.form.mobilePhone': 'Teléfono móvil',
  'users.form.roles': 'Roles',
  'users.form.positionId': 'Puesto',
  'users.form.userBossId': 'Jefe',
  'users.form.accessType': 'Tipo de Acceso',
  'users.form.isActive': 'Habilitar',

  'users.form.selectGroup': 'Selecciona un grupo',
  'users.form.selectUser': 'Selecciona un usuario',
  'users.mixed': 'Mixto',
  'users.userandpassword': 'Usuario y contraseña',
  'users.office365': 'Office365',
  'users.google': 'Google',
  'users.automy': 'AUTOMY',

  'users.config.name': 'Nombre',
  'users.form.selectEnviroment': 'Seleccione el entorno',
  'users.form.environmentIds.loginHint':
    'Si no seleccionas un entorno, esta persona no podrá iniciar sesión hasta tener un entorno accesible',

  'users.userGroupExists': 'Ya esta asignado a ese grupo de usuario',
  'users.environmentExists': 'Ya esta asignado a ese entorno',
  'users.form.twoFactorEnabled': '¿Autenticación Two-Factor Habilitada?',
  'users.column.twoFactorEnabled': '2FA',
  'users.bulk.enableTwoFactor': 'Habilitar autenticación two-factor',
  'users.bulk.disableTwoFactor': 'Deshabilitar autenticación two-factor',
  'users.selectedElements': 'elementos seleccionados',
  'users.selectedElement': 'elemento seleccionado',
  'users.environmentsTitle': 'Entornos del Usuario',
  'users.userGroups.description': 'Gestiona los grupos de usuario asignados a {name}.',
  'users.userEnvironments.description': 'Gestiona los entornos asignados a {name}.',
  'users.resetPassword.title': 'Restablecer Contraseña',
  'users.resetPassword.description': 'Define una nueva contraseña para {name}.',
  'users.import.restore.confirmCount': '¿Deseas restaurar los {count} usuarios seleccionados?',

  'users.changeEmail.action': 'Cambiar correo',
  'users.changeEmail.banner':
    'Este usuario inicia sesión con un correo distinto al que aparece aquí. Actualízalo para que sea el mismo.',
  'users.changeEmail.directory': 'Correo electrónico',
  'users.changeEmail.access': 'Correo de inicio de sesión',
  'users.changeEmail.noAccess': 'No tiene correo de inicio de sesión',
  'users.changeEmail.helper': 'Al guardar, el usuario queda con el correo que elijas.',
  'users.changeEmail.twoFactor':
    'Al cambiar el correo de inicio de sesión hay que configurar de nuevo el autenticador.',
};
